import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { discordAuth } from '../services/discordAuth';

const DiscordCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const errorParam = searchParams.get('error');

        if (errorParam) {
          setError(`Discord authorization denied: ${errorParam}`);
          setTimeout(() => navigate('/live'), 3000);
          return;
        }

        if (!code) {
          setError('No authorization code received');
          setTimeout(() => navigate('/live'), 3000);
          return;
        }

        const tokenData = await discordAuth.exchangeCodeForToken(code);
        
        if (!tokenData.access_token) {
          throw new Error('No access token in response');
        }

        discordAuth.storeToken(tokenData.access_token);

        const user = await discordAuth.getUser(tokenData.access_token);
        
        const userInfo = {
          id: user.id,
          username: user.username,
          discriminator: user.discriminator,
          avatar: user.avatar,
          access_token: tokenData.access_token
        };

        discordAuth.storeUser(userInfo);

        window.location.href = '/live';
      } catch (err) {
        console.error('Discord callback error:', err);
        setError('Failed to authenticate with Discord');
        setTimeout(() => navigate('/live'), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Authentication Error</h2>
        <p style={{ color: 'red' }}>{error}</p>
        <p>Redirecting back to live chat...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h2>Processing Discord Login...</h2>
      <p>Please wait while we authenticate your account.</p>
    </div>
  );
};

export default DiscordCallback;
